export default __webpack_public_path__ + "0feef4c5c79217510b352452b3436587.png";